/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { AcceptedResponse } from '../model/acceptedResponse';
// @ts-ignore
import { BadRequestResponse } from '../model/badRequestResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { GetFrontendFeaturesResponse } from '../model/getFrontendFeaturesResponse';
// @ts-ignore
import { SendFrontendLogsRequest } from '../model/sendFrontendLogsRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface SendFrontendLogsRequestParams {
    /** Сессионный токен */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID: string;
    sendFrontendLogsRequest: SendFrontendLogsRequest;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}


@Injectable({
  providedIn: 'root'
})
export class InfrastructureService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Получение данных о ФТ из Growthbook
     * Возвращает список фич с названием эксперимента и тегами. Данные кэшируются на 1 час.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFrontendFeatures(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GetFrontendFeaturesResponse>;
    public getFrontendFeatures(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GetFrontendFeaturesResponse>>;
    public getFrontendFeatures(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GetFrontendFeaturesResponse>>;
    public getFrontendFeatures(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (SkipSessionTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('SkipSessionTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SkipSessionTokenAuth', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'AGW',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/frontend/features`;
        return this.httpClient.request<GetFrontendFeaturesResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Отправка логов с frontend-клиентов
     * Отправляет пакет логов от клиентского устройства. Ограничения: - макс. размер тела запроса - 10 KB - конечная согласованность (логи отправляются воркерами асинхронно). 
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendFrontendLogs(requestParameters: SendFrontendLogsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AcceptedResponse>;
    public sendFrontendLogs(requestParameters: SendFrontendLogsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AcceptedResponse>>;
    public sendFrontendLogs(requestParameters: SendFrontendLogsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AcceptedResponse>>;
    public sendFrontendLogs(requestParameters: SendFrontendLogsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling sendFrontendLogs.');
        }
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling sendFrontendLogs.');
        }
        const sendFrontendLogsRequest = requestParameters.sendFrontendLogsRequest;
        if (sendFrontendLogsRequest === null || sendFrontendLogsRequest === undefined) {
            throw new Error('Required parameter sendFrontendLogsRequest was null or undefined when calling sendFrontendLogs.');
        }
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SkipSessionTokenAuth) required
        localVarCredential = this.configuration.lookupCredential('SkipSessionTokenAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SkipSessionTokenAuth', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'AGW',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/frontend/logs`;
        return this.httpClient.request<AcceptedResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sendFrontendLogsRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
